export default {
  applyToVersions: "<2.3.5",
  type: "before",
  name: "move rounds into simulation",
  migrate(data) {
    if (data?.gameRounds == null) return data;

    for (const simulationId in data.gameRounds.items) {
      const rounds = data.gameRounds.items[simulationId];
      const simulation = data.games.items[simulationId];

      // If the simulation the rounds belong to doesn't exist anymore,
      // delete the round.
      if (simulation == null) continue;

      simulation.rounds = rounds;

      // Move all planned measures and impulses out of the round,
      // leaving only the information about actually played actions/impulses/incidents...
      simulation.actionPlans = {};
      for (const round of rounds) {
        round.type = "simulationRound";

        simulation.actionPlans[round.index] = {
          plannedMeasureIds: round.measureIds,
          scheduledImpulses: round.scheduledImpulses,
          incidentChances: round.incidentChances,
          allowedRelationIds: round.allowedRelationIds,
          docs: round.docs
        };
        delete round.measureIds;
        delete round.scheduledImpulses;
        delete round.incidentChances;
        delete round.allowedRelationIds;
        delete round.docs;
      }
    }

    delete data.gameRounds;

    return data;
  }
};
